var $cc4dcfeea2b4050d$exports = {};
$cc4dcfeea2b4050d$exports = {
  "Empty": "Pusty"
};
export { $cc4dcfeea2b4050d$exports as default };